import { initialSettings } from './reducers/common/settings'

function loadState() {
  try {
    const serializedState = sessionStorage.getItem( 'smm' );
    if( serializedState === null ) {
      return undefined
    }
    const state = JSON.parse( serializedState );
    return { ...state, settings: { ...initialSettings, ...state.settings } }
  } catch( err ) {
    return undefined
  }
}

function saveState( state ) {
  try {
    const stateToPersist = {
      user: state.user,
      settings: {
        apiStatus: state.settings.apiStatus,
        networkSettings: state.settings.networkSettings,
        extraMenu: state.settings.extraMenu,
        externalAuthenticationRequired: state.settings.externalAuthenticationRequired,
        imsDomainActive: state.settings.imsDomainActive,
      },
      websocket: {
        status: state.websocket.status,
        data: state.websocket.data
      }
    };
    const serializedState = JSON.stringify( stateToPersist );
    sessionStorage.setItem( 'smm', serializedState );
  } catch( err ) {
  }
}

export { loadState, saveState };



// WEBPACK FOOTER //
// ./stores/localStorage.js